export default __webpack_public_path__ + "static/media/claims.9f756cf6.png";